// @flow
import React, {useEffect, useState} from 'react';
import {Button, Col, FormGroup, Panel, Row} from "react-bootstrap";
import type {Price, Product} from "../../../api/billing/types";


type Props = {
    product: Product,    
    visiblePrice: string, //the price type we are showing (monthly or yearly)    
};


function PerSeatProduct({product, visiblePrice}: Props) {
    const price: Price = product.prices[visiblePrice];

    const monthlyPrice = price.interval === 'month' ? price.amount : price.amount / 12;
    return (
        <Col lg={3} md={3} sm={6} xs={12} key={`${price.id}_${price.interval}`}>
            <Panel>
                <Panel.Heading
                    style={{textAlign: 'center', fontSize: 18}}>{product.name}</Panel.Heading>
                <Panel.Body style={{textAlign: 'center'}}>
                    <Row>
                        <Col xs={12}>
                            <h2 style={{marginTop: 0}}>${(monthlyPrice / 100).toFixed(2)}</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <h5>({price.currency.toUpperCase()} / seat / month, billed {price.interval === 'month' ? 'monthly' : 'yearly'} )</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <b>Features</b>
                            <ul style={{textAlign: 'left'}}>
                                {product.features.map(feature =>
                                    <li key={feature}>{feature}</li>
                                )}
                            </ul>
                        </Col>
                    </Row>                                
                </Panel.Body>
            </Panel>
        </Col>
    )
}

export default PerSeatProduct;
